import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-add-credit-card',
  templateUrl: './icon-add-credit-card.component.html',
  styleUrls: ['./icon-add-credit-card.component.scss']
})
export class IconAddCreditCardComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
